import localforage from 'localforage';

export type OnboardingFlagValue = {
  version: number;
  seenAt: string | null;
};

type CachedFlags = {
  version: number;
  flags: Record<string, OnboardingFlagValue>;
};

const VERSION = 1;
const COMPAT_VERSIONS = new Set([1]);
const KEY = (userId: string) => `cmf.onboarding.${userId}.v${VERSION}`;

export const onboardingCache = {
  async load(userId: string): Promise<Record<string, OnboardingFlagValue> | null> {
    if (!userId) return null;
    try {
      const payload = (await localforage.getItem<CachedFlags>(KEY(userId))) ?? null;
      if (!payload || !COMPAT_VERSIONS.has(payload.version)) return null;
      return payload.flags ?? null;
    } catch {
      return null;
    }
  },

  async persist(userId: string, flags: Record<string, OnboardingFlagValue>): Promise<void> {
    if (!userId) return;
    try {
      await localforage.setItem(KEY(userId), { version: VERSION, flags });
    } catch {
      // best-effort cache write
    }
  },

  async clear(userId: string): Promise<void> {
    if (!userId) return;
    try {
      await localforage.removeItem(KEY(userId));
    } catch {
      // ignore
    }
  },
};
